
<div class="col full-height layout-column">

  <!--Panel Skeleton, shown only until the resources have loaded for the first time-->
  <app-card-skeleton *ngIf="!vm.initialized" class="flex" [rows]="8"></app-card-skeleton>

  <ng-container *ngIf="vm.initialized">

    <cdk-virtual-scroll-viewport
      *ngIf="!!vm.resources && !!vm.resources?.length"
      class="flex"
      autosize
      (scroll)="getNextBatch($event)">

      <app-resources-panel-list-item *cdkVirtualFor="let resource of vm.resources; trackBy: trackById"
                                     (click)="onClick.emit(resource)"
                                     cdkDropList
                                     [id]="panel.id + '-' + resource.id"
                                     [cdkDropListConnectedTo]="allPanelIds"
                                     [cdkDropListSortingDisabled]="true"
                                     (cdkDropListDropped)="onDrop(resource, $event)"
                                     [resource]="resource"
                                     [isSelected]="selectedKeys[resource.id]"
                                     [settings]="settings"
                                     [itemElementSize]="itemElementSize"
                                     (onToggle)="onToggleSelection(resource.id, $event)">

      </app-resources-panel-list-item>

    </cdk-virtual-scroll-viewport>

    <div *ngIf="!vm.resources?.length && !vm.loading"
         class="flex layout-row layout-align-center-center fade-element-in-only overflow-auto">
      <app-empty-state src="assets/images/empty_state/empty_state_drivers.png"
                       text="No Resources Found">

      </app-empty-state>
    </div>

    <app-bringoz-linear-progress *ngIf="!!vm.loading"></app-bringoz-linear-progress>

  </ng-container>

</div>


<!--<div class="col full-height layout-column" *ngIf="vm">-->

<!--  <div class="flex layout-column dndList overflow-auto">-->


<!--    &lt;!&ndash;    <div class="route-item-test"&ndash;&gt;-->
<!--    &lt;!&ndash;         *ngFor="let task of route.taskListExt;let index = index"&ndash;&gt;-->
<!--    &lt;!&ndash;         cdkDrag&ndash;&gt;-->
<!--    &lt;!&ndash;         [cdkDragData]="task">&ndash;&gt;-->
<!--    &lt;!&ndash;      {{task.id}}&ndash;&gt;-->
<!--    &lt;!&ndash;    </div>&ndash;&gt;-->

<!--    <cdk-virtual-scroll-viewport class="flex layout-column"-->
<!--                                 (scroll)="getNextBatch($event)" autosize>-->

<!--      <app-resources-panel-list-item *cdkVirtualFor="let resource of vm.resources; trackBy: trackById"-->
<!--                                     cdkDropList-->
<!--                                     [id]="panel.id + resource.id"-->
<!--                                     [cdkDropListConnectedTo]="allPanelIds"-->
<!--                                     (cdkDropListDropped)="onDrop(resource, $event)"-->
<!--                                     [resource]="resource"-->
<!--                                     [isSelected]="selectedKeys[resource.id]"-->
<!--                                     [settings]="settings"-->
<!--                                     [itemElementSize]="itemElementSize"-->
<!--                                     (onToggle)="onToggleSelection(resource.id, $event)">-->

<!--      </app-resources-panel-list-item>-->

<!--    </cdk-virtual-scroll-viewport>-->

<!--      <app-bringoz-linear-progress *ngIf="!!vm.loading"></app-bringoz-linear-progress>-->


<!--      <div *ngIf="!vm.resources?.length && !vm.loading"-->
<!--           class="flex-100 layout-row layout-align-center-center fade-element-in-only overflow-auto">-->
<!--        <app-empty-state src="assets/images/empty_state/empty_state_drivers.png"-->
<!--                         text="No Resources Found">-->

<!--        </app-empty-state>-->
<!--      </div>-->

<!--  </div>-->

<!--</div>-->
